import createReducer from '../utils/createReducer';
import actions from '../actions/actions';

const initialState = {};
const actionHandlers = {
    [actions.FETCH_INITIAL_DATA_SUCCESS](state, {payload}) {
        const {
            billingPageRedirect,
            isBillingSetupFlow,
        } = payload.response;

        return {
            ...state,
            billingPageRedirect,
            isBillingSetupFlow,
        };
    },
};

export default createReducer(actionHandlers, initialState);
